import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "circle-questionmark, faq, help, questionaire" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M7.91683 7.91634V7.08301C7.91683 6.62277 8.28993 6.24967 8.75016 6.24967H11.2502C11.7104 6.24967 12.0835 6.62277 12.0835 7.08301V8.27785C12.0835 8.57057 11.9299 8.84182 11.6789 8.99243L10.4047 9.75692C10.1537 9.90752 10.0002 10.1788 10.0002 10.4715V12.083M10.0002 13.7497V13.758M17.9168 9.99967C17.9168 14.3719 14.3724 17.9163 10.0002 17.9163C5.62791 17.9163 2.0835 14.3719 2.0835 9.99967C2.0835 5.62742 5.62791 2.08301 10.0002 2.08301C14.3724 2.08301 17.9168 5.62742 17.9168 9.99967Z",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }